
import IndexModel from "@/service/v10/sigap/IndexModel"; 

class EnderecoService extends IndexModel { 
      
    constructor() {
        super(); 
        this.url =  this.url + '/QtsPdf' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
  
    public getTodosDaMatricula( matriculaId  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/Matricula/' + matriculaId    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
    
    public getModelLink( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id  + '/link'   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }  

  
}
  
export default EnderecoService; 